import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ContractorService } from 'src/app/Service/Contractor/Contractor.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';


@Component({
  selector: 'app-ContractorAdd',
  templateUrl: './ContractorAdd.component.html',
  styleUrls: ['./ContractorAdd.component.scss']
})
export class ContractorAddComponent implements OnInit {

  Token:String=""

  constructor(
    private Contractor_Service:ContractorService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.AddNewContractor=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token,1118).subscribe(
      data=>{
        
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  AddNewContractor:FormGroup;

  get_Form_Title(){
    return this.AddNewContractor.get('Title') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewContractor(){
    var Record:General_Interface =Empty_General_Interface()
    Record.id=0
    Record.title=this.get_Form_Title().value
    this.InProccessing=true
    this.Contractor_Service.AddContractor(Record,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The entered title already exists in the list.")
        }
        else{
          this.AddNewContractor.reset()
          this.Alertify_Service.SuccessMessage("Information saved successfully.")
        }
      },error=>{
        localStorage.clear()
        location.reload();
        
      }
    )
  }
}
